import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import {CommonsService} from '../services/commonservices/commons.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private auth: AuthService, private router: Router, private commons: CommonsService) {}
private checkLogin(route?: ActivatedRouteSnapshot): boolean | UrlTree {

  // const token = sessionStorage.getItem('1000');
  const user = this.commons.user;

  if (  !user) {
    sessionStorage.clear();
    return this.router.createUrlTree(['/login']);
  }

  // 🔴 IMPORTANT: Password change required check
  if (user.pass_time <= 0) {

    // Agar already sessionpassword pe nahi hai tab redirect karo
    if (this.router.url !== '/sessionpassword') {
      return this.router.createUrlTree(['/sessionpassword']);
    }

    return true;
  }
    if (route?.data?.['role']) {
      const expectedRole = route.data['role'];

      if (user.u_type !== expectedRole) {
        return this.router.createUrlTree(['/dashboards/welcome']);
      }
    }


  return true;
}
  // private checkLogin(): boolean | UrlTree {
  //    const token = sessionStorage.getItem('1000');  
  //   if (token && this.commons.user && Object.keys(this.commons.user).length > 0){
  //     return true;
  //   } 
  //   sessionStorage.clear();
  //   // if (this.auth.isLoggedIn()) return true;
  //   return this.router.createUrlTree(['/login']); 
    
  // }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.checkLogin(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.checkLogin(route);
  }
}
